module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("Console Booking Details")])], 1), _vm._v(" "), _c('b-card', [_c('div', {
    staticClass: "row align-items-end"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [((_vm.$route.path == '/consoleBooking' && _vm.$sessionsStorage.get('add_console_booking_pre') === '1')) ? _c('b-button', {
    staticClass: "pull-left",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.AddBookingConsole()
      }
    }
  }, [_vm._v("Add Console Booking")]) : _vm._e(), _vm._v(" "), ((_vm.$route.path == '/consoleBooking' && (_vm.$sessionsStorage.get('designation') == 'Admin' ||
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'))) ? _c('b-button', {
    staticClass: "pull-left  ml-2",
    attrs: {
      "size": "sm",
      "variant": "primary"
    },
    on: {
      "click": function($event) {
        _vm.AddBookingConsoleModal('add', '')
      }
    }
  }, [_vm._v("Add Dummy Booking")]) : _vm._e()], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Date")]), _vm._v(" "), _c('date-range-picker', {
    attrs: {
      "opens": _vm.openRight,
      "always-show-calendars": _vm.showCal,
      "startDate": _vm.startDate,
      "endDate": _vm.endDate,
      "locale-data": _vm.locale
    },
    model: {
      value: (_vm.dateRange),
      callback: function($$v) {
        _vm.dateRange = $$v
      },
      expression: "dateRange"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("BRF No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter BRF No"
    },
    model: {
      value: (_vm.BRFNoFilter),
      callback: function($$v) {
        _vm.BRFNoFilter = $$v
      },
      expression: "BRFNoFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Booking No")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.BookingNoFilter),
      callback: function($$v) {
        _vm.BookingNoFilter = $$v
      },
      expression: "BookingNoFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.clientMaster,
      "id": "clientName",
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.clientIdFilter),
      callback: function($$v) {
        _vm.clientIdFilter = $$v
      },
      expression: "clientIdFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("\n          Agent Name :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-2",
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    model: {
      value: (_vm.agentIdFilter),
      callback: function($$v) {
        _vm.agentIdFilter = $$v
      },
      expression: "agentIdFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Shipping Line")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.ShippingLineList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ShippingLineFilter),
      callback: function($$v) {
        _vm.ShippingLineFilter = $$v
      },
      expression: "ShippingLineFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.$sessionsStorage.get('cust_username') == 'Admin' ||
        _vm.$sessionsStorage.get('cust_username') == 'admin' ||
        _vm.$sessionsStorage.get('cust_username') == 'shankarrawat' ||
        _vm.$sessionsStorage.get('cust_username') == 'vijaysharma' ||
        _vm.$sessionsStorage.get('cust_username') == 'rathishnair' ||
        _vm.$sessionsStorage.get('cust_username') == 'aaryav' ?
        false :
        true,
      "list": _vm.BranchList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Branch"
    },
    model: {
      value: (_vm.BranchFilter),
      callback: function($$v) {
        _vm.BranchFilter = $$v
      },
      expression: "BranchFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Booking Status")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BookingStatusList,
      "id": "BookingStatus",
      "option-value": "inv",
      "option-text": "int",
      "placeholder": "Select Status"
    },
    model: {
      value: (_vm.BookingStatusFilter),
      callback: function($$v) {
        _vm.BookingStatusFilter = $$v
      },
      expression: "BookingStatusFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("POR")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.PORfilter),
      callback: function($$v) {
        _vm.PORfilter = $$v
      },
      expression: "PORfilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("POD")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.PODfilter),
      callback: function($$v) {
        _vm.PODfilter = $$v
      },
      expression: "PODfilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("POL")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      }
    },
    model: {
      value: (_vm.POLfilter),
      callback: function($$v) {
        _vm.POLfilter = $$v
      },
      expression: "POLfilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Contract No")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContractList'],
      "id": "fk_contract_id",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Contract NUMBER"
    },
    on: {
      "input": function($event) {
        _vm.getContractNoBasedVessel(_vm.fk_contract_idFilter)
      }
    },
    model: {
      value: (_vm.fk_contract_idFilter),
      callback: function($$v) {
        _vm.fk_contract_idFilter = $$v
      },
      expression: "fk_contract_idFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', [_vm._v("Vessel Name ")]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    attrs: {
      "list": _vm.$store.getters['common/getAllContractBasedVesselList'],
      "id": "vessel_name",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vessel Name"
    },
    model: {
      value: (_vm.fk_ccbm_idFilter),
      callback: function($$v) {
        _vm.fk_ccbm_idFilter = $$v
      },
      expression: "fk_ccbm_idFilter"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-12 mt-2 text-right"
  }, [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.filterSearch
    }
  }, [_vm._v("Search")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": _vm.clearFilter
    }
  }, [_vm._v("clear")]), _vm._v(" "), ((_vm.$route.path == '/consoleBooking' || (_vm.$sessionsStorage.get('designation') == 'Admin' &&
    _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'))) ? _c('b-button', {
    staticClass: "ml-3",
    attrs: {
      "disabled": _vm.ExcelBtnName != 'Export as Excel' ? true : false,
      "size": "sm",
      "variant": "outline-info"
    },
    on: {
      "click": function($event) {
        _vm.getReports('ConsoleBooking_SCREEN', 'Export as Excel')
      }
    }
  }, [_vm._v(_vm._s(_vm.ExcelBtnName) + "\n              "), (_vm.ExcelBtnName != 'Export as Excel') ? _c('b-spinner', {
    attrs: {
      "small": "",
      "label": "Small Spinner"
    }
  }) : _vm._e()], 1) : _vm._e()], 1)]), _vm._v(" "), _c('b-modal', {
    ref: "Contract-modal",
    staticClass: "w-90",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": "Add Contract"
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "12"
    }
  }, [_c('label', [_vm._v("Contract No "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.contractModal.cb_contarct_no && _vm.errorContractList.cb_contarct_no ?
        'red' :
        '',
    }),
    attrs: {
      "disabled": _vm.contractModal.cb_id > 0 ? true : false,
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "cb_contarct_no",
      "name": "cb_contarct_no"
    },
    model: {
      value: (_vm.contractModal.cb_contarct_no),
      callback: function($$v) {
        _vm.$set(_vm.contractModal, "cb_contarct_no", $$v)
      },
      expression: "contractModal.cb_contarct_no"
    }
  }), _vm._v(" "), (!_vm.contractModal.cb_contarct_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorContractList.cb_contarct_no))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.contractDisabled,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addContract
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideContractModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "vesselModalRef",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Add Vessel/Voyage-' + _vm.ConsoleBookDetails.contract_no
    }
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Contract No "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor:
        !_vm.vesselModal.fk_contract_id && _vm.errorVesselList.fk_contract_id ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllContractList'],
      "id": "fk_contract_id",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Contract NUMBER"
    },
    on: {
      "input": function($event) {
        _vm.getContractNo(_vm.vesselModal.fk_contract_id)
      }
    },
    model: {
      value: (_vm.vesselModal.fk_contract_id),
      callback: function($$v) {
        _vm.$set(_vm.vesselModal, "fk_contract_id", $$v)
      },
      expression: "vesselModal.fk_contract_id"
    }
  }), _vm._v(" "), (!_vm.vesselModal.fk_contract_id && _vm.errorVesselList.fk_contract_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n              " + _vm._s(_vm.errorVesselList.fk_contract_id) + "\n            ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Vessel Name "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.vesselModal.vessel_name && _vm.errorVesselList.vessel_name ?
        'red' :
        '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "vessel_name",
      "name": "vessel_name"
    },
    model: {
      value: (_vm.vesselModal.vessel_name),
      callback: function($$v) {
        _vm.$set(_vm.vesselModal, "vessel_name", $$v)
      },
      expression: "vesselModal.vessel_name"
    }
  }), _vm._v(" "), (!_vm.vesselModal.vessel_name) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVesselList.vessel_name))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("Voyage No "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.vesselModal.vessel_voyage_no && _vm.errorVesselList.vessel_voyage_no ?
        'red' :
        '',
    }),
    attrs: {
      "size": "sm",
      "formatter": _vm.capitalizeAll,
      "id": "vessel_voyage_no",
      "name": "vessel_voyage_no"
    },
    model: {
      value: (_vm.vesselModal.vessel_voyage_no),
      callback: function($$v) {
        _vm.$set(_vm.vesselModal, "vessel_voyage_no", $$v)
      },
      expression: "vesselModal.vessel_voyage_no"
    }
  }), _vm._v(" "), (!_vm.vesselModal.vessel_voyage_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVesselList.vessel_voyage_no))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('label', [_vm._v("SOB "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    style: ({
      borderColor:
        !_vm.vesselModal.vessel_sail_date && _vm.errorVesselList.vessel_sail_date ? 'red' : '',
    }),
    attrs: {
      "type": "date"
    },
    model: {
      value: (_vm.vesselModal.vessel_sail_date),
      callback: function($$v) {
        _vm.$set(_vm.vesselModal, "vessel_sail_date", $$v)
      },
      expression: "vesselModal.vessel_sail_date"
    }
  }), _vm._v(" "), (!_vm.vesselModal.vessel_sail_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorVesselList.vessel_sail_date))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-3 text-center"
  }, [_c('b-button', {
    attrs: {
      "disabled": _vm.contractDisabled,
      "variant": "outline-primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": _vm.addVesselVoyage
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "outline-danger",
      "size": "sm"
    },
    on: {
      "click": _vm.hideVesselModal
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "ml-2 text-right",
    attrs: {
      "cols": "12"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [_c('div', [_c('b-pagination', {
    staticClass: "mt-3",
    staticStyle: {
      "margin": "0px"
    },
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1), _vm._v(" "), _c('div', [_c('b-row', {
    staticClass: "align-content-end mt-3"
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h5', {
    staticClass: "text-muted pull-right"
  }, [(_vm.isLoading == false) ? _c('small', [_vm._v(_vm._s(_vm.totalRows) + " Entries")]) : _vm._e()])]), _vm._v(" "), _c('b-col', {
    staticStyle: {
      "padding": "0px 1rem 0 5rem"
    },
    attrs: {
      "cols": "2"
    }
  }, [_c('model-list-select', {
    attrs: {
      "list": _vm.PaginationList,
      "option-value": "pagv",
      "option-text": "pagt",
      "placeholder": "Select"
    },
    on: {
      "input": function($event) {
        _vm.pagechangeData()
      }
    },
    model: {
      value: (_vm.PaginationCount),
      callback: function($$v) {
        _vm.PaginationCount = $$v
      },
      expression: "PaginationCount"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "table-responsive tableMain mt-2"
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "items": _vm.consoBooking,
      "fields": _vm.fields,
      "per-page": _vm.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.currentPage - 1) * _vm.perPage))])]
      }
    }, {
      key: "booking_no",
      fn: function(row1) {
        return [(row1.item.bookingType) ? _c('span', [_vm._v("\n                Booking Type. :" + _vm._s(row1.item.bookingType) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.contract_no) ? _c('span', [_vm._v("\n                Contract No. :" + _vm._s(row1.item.contract_no) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), _c('b', {
          style: (row1.item.SubscriptionId ? 'color: blue;font-weight:bold' : ''),
          on: {
            "click": function($event) {
              row1.item.SubscriptionId ? _vm.goToSubscriptionPage(row1.item) : ''
            }
          }
        }, [_vm._v(_vm._s(row1.item.booking_no))]), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.SubscriptionId) ? _c('BookingTrack', {
          attrs: {
            "containerArr": '',
            "slineName": row1.item.shippingLine,
            "clientName": row1.item.ClientName,
            "modal_title": ("Container Movement Booking No: " + (row1.item.booking_no) + " Job No - " + (row1.item.mainSeries) + " Client: " + (row1.item.ClientName)),
            "JOBNO": row1.item.mainSeries,
            "shipment_id": Number(0),
            "subscription_id": Number(0),
            "fk_sub_track_id": Number(0),
            "fk_all_module_id": Number(row1.item.allModuleId),
            "fk_booking_id": Number(row1.item.booking_id),
            "fk_container_id": Number(0),
            "booking_number": row1.item.booking_no,
            "container_number": ''
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("\n                Created Dt. :" + _vm._s(_vm._f("moment")(row1.item.created_at)) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("Release Dt. :" + _vm._s(_vm._f("moment")(row1.item.release_date)))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("\n                Raised From : " + _vm._s(row1.item.raisedFrom) + "\n                "), _c('br')]), _vm._v(" "), _c('span', [_vm._v("By : " + _vm._s(row1.item.raisedBy))]), _vm._v(" "), _c('br'), _vm._v(" "), (row1.item.enquiry_booking_no) ? _c('span', [_vm._v("\n                BRF No. :"), _c('b', [_vm._v(_vm._s(row1.item.enquiry_booking_no))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.enquiry_no) ? _c('span', [_vm._v("\n                Enq No. :"), _c('b', [_vm._v(_vm._s(row1.item.enquiry_no))]), _vm._v(" "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.UpdatedBy) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("\n                Update Dt : " + _vm._s(row1.item.UpdatedDate) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row1.item.UpdatedBy) ? _c('span', {
          staticClass: "error"
        }, [_vm._v("Update By : " + _vm._s(row1.item.UpdatedBy))]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "ClientName",
      fn: function(row2) {
        return [(row2.item.booking_for) ? _c('b', [_vm._v(_vm._s("Booking For : " + row2.item.booking_for))]) : _vm._e(), _c('br'), _vm._v(" "), (row2.item.fk_agent_id == '0' && row2.item.booking_for == 'Agent') ? _c('b', [_vm._v(_vm._s("NOT AVAILABLE"))]) : (row2.item.AgentName != '' && row2.item.booking_for == 'Agent') ? _c('b', [_vm._v(_vm._s(row2.item.AgentName))]) : _vm._e(), _c('br'), _vm._v(" "), (row2.item.fk_client_id == '0' && row2.item.booking_for == 'Client') ? _c('b', [_vm._v(_vm._s("NOT AVAILABLE"))]) : (row2.item.ClientName != '' && row2.item.booking_for == 'Client') ? _c('b', [_vm._v(_vm._s(row2.item.ClientName))]) : _vm._e(), _vm._v(" "), (row2.item.fk_agent_id == '0' && !row2.item.booking_for) ? _c('b', [_vm._v(_vm._s("NOT AVAILABLE"))]) : (row2.item.AgentName != '' && !row2.item.booking_for) ? _c('b', [_vm._v(_vm._s(row2.item.AgentName))]) : _vm._e(), _c('br'), _vm._v(" "), (row2.item.fk_client_id == '0' && !row2.item.booking_for) ? _c('b', [_vm._v(_vm._s("NOT AVAILABLE"))]) : (row2.item.ClientName != '' && !row2.item.booking_for) ? _c('b', [_vm._v(_vm._s(row2.item.ClientName))]) : _vm._e()]
      }
    }, {
      key: "shippingLine",
      fn: function(row3) {
        return [(row3.item.shippingLine != '') ? _c('b', [_vm._v(_vm._s(row3.item.shippingLine))]) : _vm._e()]
      }
    }, {
      key: "POD",
      fn: function(row3) {
        return [_vm._v("\n              Branch :\n              "), (row3.item.Branch_Name != '') ? _c('b', [_vm._v("\n                " + _vm._s(row3.item.Branch_Name) + "\n              ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("POR :\n              "), (row3.item.POR != '') ? _c('b', [_vm._v(_vm._s(row3.item.POR))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("POD :\n              "), (row3.item.POD != '') ? _c('b', [_vm._v(_vm._s(row3.item.POD))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v("POL :\n              "), (row3.item.POL != '') ? _c('b', [_vm._v(_vm._s(row3.item.POL))]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "vessel_sale_start_date",
      fn: function(row10) {
        return [(row10.item.validity_start != '') ? _c('b', [_vm._v("Validity Date : " + _vm._s(row10.item.validity_start))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row10.item.validity_end != '') ? _c('b', [_vm._v("/" + _vm._s(row10.item.validity_end))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row10.item.vessel_sale_start_date != '') ? _c('b', [_vm._v("Vessel Sail Date : " + _vm._s(row10.item.vessel_sale_start_date))]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row10.item.vessel_sale_end_date != '') ? _c('b', [_vm._v("/" + _vm._s(row10.item.vessel_sale_end_date))]) : _vm._e(), _vm._v(" "), _c('br')]
      }
    }, {
      key: "mainSeries",
      fn: function(row6) {
        return [_vm._v(_vm._s(row6.item.mainSeries))]
      }
    }, {
      key: "BookingStatus",
      fn: function(row5) {
        return (_vm.$route.path == '/consoleBooking' || (_vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh')) ? [(row5.item.validity_docArr) ? _c('span', [(row5.item.validity_docArr.length > 0) ? _c('b', _vm._l((_vm.sanitizedArray(row5.item.validity_docArr)), function(item_doc, index_doc) {
          return _c('span', {
            key: index_doc
          }, [(item_doc != '' && row5.item.BookingStatus == '1') ? _c('b-button', {
            staticClass: "mb-1",
            staticStyle: {
              "margin-left": "2px",
              "font-size": "0.675rem"
            },
            attrs: {
              "size": "sm",
              "variant": "warning"
            },
            on: {
              "click": function($event) {
                _vm.PrintValidity_Doc(item_doc)
              }
            }
          }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), _c('br')], 1)
        })) : _c('b', [(
          row5.item.validity_docArr != '' &&
          row5.item.validity_docArr != undefined &&
          row5.item.validity_docArr != null &&
          row5.item.BookingStatus == '1'
        ) ? _c('a', {
          staticStyle: {
            "margin-left": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "href": "javascript:void(0)",
            "size": "sm",
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.PrintValidity_Doc(row5.item.validity_docArr)
            }
          }
        }, [_vm._v("PDF")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "success"
          },
          on: {
            "click": function($event) {
              row5.item.approval_request == '1' ? _vm.sendApprovalRequestModal(row5.item) : _vm.getApprovalRequestLog(row5.item)
            }
          }
        }, [_vm._v("\n                 " + _vm._s(row5.item.approval_request == '1' ? 'Send Approval Request' : 'Request Approval Log') + "\n                "), _c('br')]), _vm._v(" "), (row5.item.BookingStatus == '1' && (row5.item.approval_request == '0' && row5.item.is_approval_mail_action == '0')) ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "success"
          },
          on: {
            "click": function($event) {
              _vm.AddOtherCBDetails('edit', row5.item)
            }
          }
        }, [_vm._v("\n                RELEASED\n                "), _c('br')]) : (row5.item.BookingStatus == '2' && (row5.item.approval_request == '0' || row5.item.is_approval_mail_action == '1')) ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              _vm.AddOtherCBDetails('add', row5.item)
            }
          }
        }, [_vm._v("\n                UNRELEASED\n                "), _c('br')]) : (row5.item.BookingStatus == 3) ? _c('b-button', {
          staticClass: "mt-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "variant": "warning"
          },
          on: {
            "click": function($event) {
              _vm.RemoveBookingConsole('CANCELLED', row5.item)
            }
          }
        }, [_vm._v("CANCELLED")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row5.item.BookingStatus == 3 && row5.item.closedBy != '') ? _c('span', [_vm._v("\n                CANCELLED By:" + _vm._s(_vm.wordWrap(row5.item.closedBy, 24)) + "\n                "), _c('br'), _vm._v("\n                CANCELLED Remark:" + _vm._s(_vm.wordWrap(row5.item.closingReasontxt, 24)) + "\n              ")]) : _vm._e()] : undefined
      }
    }, {
      key: "booking_id",
      fn: function(row4) {
        return (_vm.$route.path == '/consoleBooking' || (_vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh')) ? [(
          _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
        ) ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.AddBookingConsoleModal('edit', row4.item)
            }
          }
        }, [_vm._v("\n                Edit\n                "), _c('br')]) : _vm._e(), _vm._v(" "), (row4.item.prbr_id > 0) ? _c('BRFCard', {
          attrs: {
            "BRFDetails": row4.item,
            "prbr_id": Number(row4.item.prbr_id)
          }
        }) : _vm._e(), _vm._v(" "), _c('span', [_vm._v("Used Status: " + _vm._s(row4.item.is_subscription_tracking_status))]), _vm._v(" "), (_vm.$sessionsStorage.get('designation') == 'Admin' && row4.item.is_subscription_tracking_status == 'Yes') ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": "primary"
          },
          on: {
            "click": function($event) {
              _vm.ResetBookingConsole(row4.item)
            }
          }
        }, [_vm._v("\n                Reset Booking \n                "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.prbr_id > 0 && row4.item.booking_id > 0 && _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh') ? _c('ToggleBRFSwitch', {
          attrs: {
            "brf_no": row4.item.enquiry_booking_no,
            "booking_no": row4.item.booking_no,
            "booking_id": Number(row4.item.booking_id),
            "prbr_id": Number(row4.item.prbr_id),
            "isbookingactive": Number(row4.item.isbookingactive),
            "prbr_is_active": Number(row4.item.prbr_is_active),
            "request_type": 'ConsoleBooking'
          },
          on: {
            "success": _vm.viewBookingConsoleList
          }
        }) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
          _vm.$sessionsStorage.get('designation') == 'Admin' &&
          _vm.$sessionsStorage.get('nameUser') == 'Bhavneesh'
        ) ? _c('b-button', {
          staticClass: "mb-1",
          staticStyle: {
            "font-size": "0.675rem"
          },
          attrs: {
            "size": "sm",
            "variant": row4.item.isbookingactive == 1 ? 'danger' : 'success'
          },
          on: {
            "click": function($event) {
              _vm.RemoveBookingConsole(
                row4.item.isbookingactive == 1 ? 'remove' : 'recover',
                row4.item
              )
            }
          }
        }, [_vm._v("\n                " + _vm._s(row4.item.bookingactive_status_txt) + "\n                "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.booking_id != '' && row4.item.BookingStatus != 3) ? _c('b-button', {
          staticClass: "ml-2 mb-1",
          staticStyle: {
            "margin-left": "2px",
            "font-size": "0.675rem"
          },
          attrs: {
            "disabled": row4.item.assignmentNumber ? true : false,
            "size": "sm",
            "variant": "danger"
          },
          on: {
            "click": function($event) {
              _vm.CancelBooking(row4.item, '3')
            }
          }
        }, [_vm._v("\n                Cancel\n                "), _c('br')]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (row4.item.assignmentNumber != '') ? _c('span', [_vm._v("\n                " + _vm._s(row4.item.assignmentNumber) + "\n              ")]) : _vm._e()] : undefined
      }
    }])
  })], 1)]), _vm._v(" "), _c('div', [_c('b-pagination', {
    attrs: {
      "limit": "25",
      "align": "center",
      "per-page": _vm.perPage,
      "total-rows": _vm.totalRows
    },
    on: {
      "change": function($event) {
        _vm.onPageChange($event)
      }
    },
    model: {
      value: (_vm.currentPage),
      callback: function($$v) {
        _vm.currentPage = $$v
      },
      expression: "currentPage"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('b-modal', {
    ref: "modal-Add-Open",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": _vm.ConsoleBookDetails.CBType == 'add' ?
        'Add Console Booking' :
        'Update Console Booking'
    }
  }, [_c('b-row', [_c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          \n          Branch :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-2",
    attrs: {
      "isDisabled": _vm.$sessionsStorage.get('cust_username') == 'Admin' ||
        _vm.$sessionsStorage.get('cust_username') == 'admin' ||
        _vm.$sessionsStorage.get('cust_username') == 'shankarrawat' ||
        _vm.$sessionsStorage.get('cust_username') == 'vijaysharma' ||
        _vm.$sessionsStorage.get('cust_username') == 'rathishnair' ||
        _vm.$sessionsStorage.get('cust_username') == 'aaryav' ?
        false :
        true,
      "list": _vm.BranchList,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Branch"
    },
    model: {
      value: (_vm.ConsoleBookDetails.fk_branch_id),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "fk_branch_id", $$v)
      },
      expression: "ConsoleBookDetails.fk_branch_id"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.fk_branch_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.fk_branch_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "fk_enq_price_id"
    }
  }, [_vm._v("\n          Enquiry Pricing No. :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['enqPriceEngineDropdown/getAllEnqPriceDDList'],
      "id": "fk_enq_price_id",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Pricing No"
    },
    on: {
      "input": function($event) {
        _vm.updateBookingRes(_vm.ConsoleBookDetails.fk_enq_price_id)
      }
    },
    model: {
      value: (_vm.ConsoleBookDetails.fk_enq_price_id),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "fk_enq_price_id", $$v)
      },
      expression: "ConsoleBookDetails.fk_enq_price_id"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.fk_enq_price_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.fk_enq_price_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "bkgType"
    }
  }, [_vm._v("Booking Type")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.BookingTypeList,
      "option-value": "bkgval",
      "option-text": "bkgtxt",
      "placeholder": "Select Booking Type"
    },
    model: {
      value: (_vm.ConsoleBookDetails.bookingType),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "bookingType", $$v)
      },
      expression: "ConsoleBookDetails.bookingType"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.bookingType) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.bookingType) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Booking No. :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.ConsoleBookDetails.booking_no),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "booking_no", $$v)
      },
      expression: "ConsoleBookDetails.booking_no"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.booking_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.booking_no) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.ConsoleBookDetails.booking_for = 'Client') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Client Name :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-2",
    attrs: {
      "list": _vm.clientMaster,
      "option-value": "clientId",
      "option-text": "clientName",
      "placeholder": "Select Client Name"
    },
    model: {
      value: (_vm.ConsoleBookDetails.fk_client_id),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "fk_client_id", $$v)
      },
      expression: "ConsoleBookDetails.fk_client_id"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.fk_client_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.fk_client_id) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.ConsoleBookDetails.booking_for = 'Agent') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "agentName"
    }
  }, [_vm._v("\n          Agent Name :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-2",
    attrs: {
      "list": _vm.$store.getters['common/getAllAgentColoaderList'],
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Agent Name"
    },
    model: {
      value: (_vm.ConsoleBookDetails.fk_agent_id),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "fk_agent_id", $$v)
      },
      expression: "ConsoleBookDetails.fk_agent_id"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.fk_agent_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.fk_agent_id) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Shipping Line :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-2",
    attrs: {
      "list": _vm.ShippingLineList,
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    model: {
      value: (_vm.ConsoleBookDetails.fk_shippingline_id),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "fk_shippingline_id", $$v)
      },
      expression: "ConsoleBookDetails.fk_shippingline_id"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.fk_shippingline_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.fk_shippingline_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), (_vm.ConsoleBookDetails.bookingType === 'ON CONTRACT') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Contract No. :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllMultiContractList'],
      "id": "contract_no",
      "option-value": "text",
      "option-text": "text",
      "placeholder": "Select Contract No"
    },
    on: {
      "input": function($event) {
        _vm.changeContractNo(_vm.ConsoleBookDetails.contract_no)
      }
    },
    model: {
      value: (_vm.ConsoleBookDetails.contract_no),
      callback: function($$v) {
        _vm.$set(_vm.ConsoleBookDetails, "contract_no", $$v)
      },
      expression: "ConsoleBookDetails.contract_no"
    }
  }), _vm._v(" "), (!_vm.ConsoleBookDetails.contract_no && _vm.ConsoleBookDetails.bookingType === 'ON CONTRACT') ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBDetails.contract_no) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.ConsoleBookDetails.booking_no != '') ? _c('b-button', {
    staticClass: "mt-3 sm",
    attrs: {
      "disabled": _vm.isCBdisabled || !_vm.ConsoleBookDetails.booking_no,
      "variant": "success"
    },
    on: {
      "click": _vm.submitConsoleBooking
    }
  }, [_vm._v(_vm._s(_vm.buttonTxt))]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3 sm",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeModalAdd
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-AddOther-Open",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": 'Add Other Details'
    }
  }, [_c('b-row', [(_vm.CBValidityDetails.is_booing_response == 1) ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', [_vm._v("Booking No:"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "type": "text",
      "placeholder": "Enter Booking No"
    },
    model: {
      value: (_vm.CBValidityDetails.booking_no),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "booking_no", $$v)
      },
      expression: "CBValidityDetails.booking_no"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.booking_no) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.booking_no) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openContractModal()
      }
    }
  }, [_vm._v("Add Contract")]), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader",
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.openVesselModal()
      }
    }
  }, [_vm._v("Add Vessel")])], 1), _vm._v(" "), (_vm.booking_type_status == '1') ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered mt-2"
  }, [_c('tbody', {
    staticStyle: {
      "background": "white"
    }
  }, [(_vm.CONTAINERCOUNTArr.length > 0) ? _c('tr', [_c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("SN.")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("CONTAINER TYPE")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("CONTAINER COUNT")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("CURRENCY")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "180px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("BUYING OCEAN FREIGHT")]), _vm._v(" "), _c('th', {
    staticStyle: {
      "width": "5px"
    },
    attrs: {
      "scope": "col"
    }
  }, [_vm._v("\n                Actions\n                "), _c('b-button', {
    attrs: {
      "disabled": _vm.CBValidityDetails_inputFlag,
      "size": "sm"
    },
    on: {
      "click": function($event) {
        _vm.addContainerCount()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })])], 1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.CONTAINERCOUNTArr), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('th', {
      attrs: {
        "scope": "row"
      }
    }, [_vm._v(_vm._s(index + 1) + ".")]), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.CBValidityDetails_inputFlag,
        "list": _vm.containerList,
        "option-value": "value",
        "option-text": "text",
        "placeholder": "Select Container Type"
      },
      model: {
        value: (item.cont_type),
        callback: function($$v) {
          _vm.$set(item, "cont_type", $$v)
        },
        expression: "item.cont_type"
      }
    }), _vm._v(" "), (item.cont_type_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.cont_type_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "disabled": _vm.CBValidityDetails_inputFlag,
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Container Count"
      },
      model: {
        value: (item.cont_count),
        callback: function($$v) {
          _vm.$set(item, "cont_count", $$v)
        },
        expression: "item.cont_count"
      }
    }), _vm._v(" "), (item.cont_count_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.cont_count_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('model-list-select', {
      attrs: {
        "isDisabled": _vm.CBValidityDetails_inputFlag,
        "list": _vm.CurrencyList,
        "option-value": "currency_id",
        "option-text": "currencyCode",
        "placeholder": "Select Currency"
      },
      model: {
        value: (item.currency),
        callback: function($$v) {
          _vm.$set(item, "currency", $$v)
        },
        expression: "item.currency"
      }
    }), _vm._v(" "), (item.currency_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.currency_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('b-form-input', {
      attrs: {
        "disabled": _vm.CBValidityDetails_inputFlag,
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter BUYING OCEAN FREIGHT"
      },
      model: {
        value: (item.buying_ocean_freight),
        callback: function($$v) {
          _vm.$set(item, "buying_ocean_freight", $$v)
        },
        expression: "item.buying_ocean_freight"
      }
    }), _vm._v(" "), (item.buying_ocean_freight_err ? true : false) ? _c('span', {
      staticClass: "error"
    }, [_vm._v(_vm._s(item.buying_ocean_freight_err))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(index > 0) ? _c('b-button', {
      attrs: {
        "size": "sm",
        "disabled": _vm.CBValidityDetails_inputFlag
      },
      on: {
        "click": function($event) {
          _vm.removeContainerCount(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)])
  })], 2)])]) : _vm._e(), _vm._v(" "), (_vm.booking_type_status == '0') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          CONTAINER TYPE :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-select', {
    attrs: {
      "isDisabled": _vm.CBValidityDetails_inputFlag,
      "options": _vm.containerList,
      "selected-options": _vm.items,
      "placeholder": "Select Container Type",
      "multiple": true
    },
    on: {
      "select": _vm.SelectContainerType
    },
    model: {
      value: (_vm.CBValidityDetails.containerTypeDet),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "containerTypeDet", $$v)
      },
      expression: "CBValidityDetails.containerTypeDet"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.containerTypeDet) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.containerTypeDet) + "\n        ")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.booking_type_status == '0') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.booking_type_status == '0') ? _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }) : _vm._e(), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Validity Start. :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.CBValidityDetails_inputFlag,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "minute-step": 1,
      "name": "validity_start",
      "id": "validity_start"
    },
    model: {
      value: (_vm.CBValidityDetails.validity_start),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "validity_start", $$v)
      },
      expression: "CBValidityDetails.validity_start"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.validity_start) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.validity_start) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Validity End. :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.CBValidityDetails_inputFlag,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "minute-step": 1,
      "name": "validity_end",
      "id": "validity_end"
    },
    model: {
      value: (_vm.CBValidityDetails.validity_end),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "validity_end", $$v)
      },
      expression: "CBValidityDetails.validity_end"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.validity_end) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.validity_end) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Vessel Sail Date :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")]), _vm._v(" "), _c('br')]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": _vm.CBValidityDetails_inputFlag,
      "format": _vm.selectDateFormat,
      "lang": "en",
      "minute-step": 1,
      "name": "vessel_sale_start_date",
      "id": "vessel_sale_start_date"
    },
    on: {
      "input": function($event) {
        _vm.ChangeVessalesEndDate(_vm.CBValidityDetails.vessel_sale_start_date)
      }
    },
    model: {
      value: (_vm.CBValidityDetails.vessel_sale_start_date),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "vessel_sale_start_date", $$v)
      },
      expression: "CBValidityDetails.vessel_sale_start_date"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.vessel_sale_start_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCBValidityDetails.vessel_sale_start_date))]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Last Date Of Cancellation")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "disabled": "",
      "format": _vm.selectDateFormat,
      "lang": "en",
      "minute-step": 1,
      "name": "vessel_sale_end_date",
      "id": "vessel_sale_end_date"
    },
    model: {
      value: (_vm.CBValidityDetails.vessel_sale_end_date),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "vessel_sale_end_date", $$v)
      },
      expression: "CBValidityDetails.vessel_sale_end_date"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.vessel_sale_end_date) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.vessel_sale_end_date) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          POR :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.CBValidityDetails_inputFlag,
      "list": _vm.finalAllPlaceDataPOR,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Place of Receipt"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOR')
      }
    },
    model: {
      value: (_vm.CBValidityDetails.fk_por_id),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "fk_por_id", $$v)
      },
      expression: "CBValidityDetails.fk_por_id"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.fk_por_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.fk_por_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          POD :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.CBValidityDetails_inputFlag,
      "list": _vm.finalAllPlaceDataPOD,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Port of Discharge"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataPOD')
      }
    },
    model: {
      value: (_vm.CBValidityDetails.fk_pod_id),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "fk_pod_id", $$v)
      },
      expression: "CBValidityDetails.fk_pod_id"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.fk_pod_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.fk_pod_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          POL :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "isDisabled": _vm.CBValidityDetails_inputFlag,
      "list": _vm.finalAllPlaceDataLP,
      "option-value": "pickupId",
      "option-text": "pickupLocation",
      "placeholder": "Select Load Port"
    },
    on: {
      "input": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      },
      "searchchange": function($event) {
        _vm.getLocationList($event, 'All', 'finalAllPlaceDataLP')
      }
    },
    model: {
      value: (_vm.CBValidityDetails.fk_pol_id),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "fk_pol_id", $$v)
      },
      expression: "CBValidityDetails.fk_pol_id"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.fk_pol_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.fk_pol_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "3"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Vessel Name :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    staticClass: "ml-1",
    style: ({
      borderColor:
        !_vm.CBValidityDetails.fk_ccbm_id && _vm.errorCBValidityDetails.fk_ccbm_id ?
        'red' :
        '',
    }),
    attrs: {
      "list": _vm.$store.getters['common/getAllContractBasedVesselList'],
      "id": "vessel_name",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Vessel Name"
    },
    on: {
      "input": function($event) {
        _vm.getAllContractBasedVesselList(_vm.CBValidityDetails.fk_ccbm_id)
      }
    },
    model: {
      value: (_vm.CBValidityDetails.fk_ccbm_id),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "fk_ccbm_id", $$v)
      },
      expression: "CBValidityDetails.fk_ccbm_id"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.fk_ccbm_id && _vm.errorCBValidityDetails.fk_ccbm_id) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.fk_ccbm_id) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Remark :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "disabled": _vm.CBValidityDetails_inputFlag,
      "formatter": _vm.capitalizeAll,
      "id": "remark",
      "name": "remark"
    },
    model: {
      value: (_vm.CBValidityDetails.remark),
      callback: function($$v) {
        _vm.$set(_vm.CBValidityDetails, "remark", $$v)
      },
      expression: "CBValidityDetails.remark"
    }
  }), _vm._v(" "), (!_vm.CBValidityDetails.remark) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.remark) + "\n        ")]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "mt-2",
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("\n          Validity Doc. :\n          "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('multi-file-uploader', {
    style: ("height: 79px;    background: darkgray;    width: 300px;"),
    attrs: {
      "disabled": _vm.CBValidityDetails_inputFlag,
      "documentName": 'BOOKING_ORDER_',
      "otherDocName": 'BOOKING_ORDER_',
      "folderName": 'Console_Booking_Doc',
      "accept": '*',
      "assign_no": 'Console_Booking_Doc',
      "multiple": true,
      "state": Boolean(_vm.singleUpload),
      "fileAllModuleId": ''
    },
    model: {
      value: (_vm.singleUpload),
      callback: function($$v) {
        _vm.singleUpload = $$v
      },
      expression: "singleUpload"
    }
  }), _vm._v(" "), (_vm.validity_doc_error) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(" Document is Required ")]) : _vm._e(), _vm._v(" "), (!_vm.ConsoleBookDetails.validity_doc) ? _c('span', {
    staticClass: "error"
  }, [_vm._v("\n          " + _vm._s(_vm.errorCBValidityDetails.validity_doc) + "\n        ")]) : _vm._e(), _vm._v(" "), _c('br'), _vm._v(" "), (
    _vm.CBValidityDetails.validity_doc != '' &&
    _vm.CBValidityDetails.validity_doc != undefined &&
    _vm.CBValidityDetails.validity_doc != null
  ) ? _c('b', [(_vm.CBValidityDetails.validity_doc) ? _c('span', [(_vm.CBValidityDetails.validity_doc.split(',').length > 0) ? _c('b', _vm._l((_vm.sanitizedArray(_vm.CBValidityDetails.validity_doc.split(','))), function(item_doc, index_doc) {
    return _c('span', {
      key: index_doc
    }, [(item_doc != '') ? _c('a', {
      attrs: {
        "href": "javascript:void(0)"
      },
      on: {
        "click": function($event) {
          _vm.PrintValidity_Doc(item_doc)
        }
      }
    }, [_vm._v("View Document - " + _vm._s(index_doc + 1))]) : _vm._e(), _vm._v(" "), _c('br')])
  })) : _c('b', [(
    _vm.CBValidityDetails.validity_doc != '' &&
    _vm.CBValidityDetails.validity_doc != undefined &&
    _vm.CBValidityDetails.validity_doc != null
  ) ? _c('a', {
    attrs: {
      "href": "javascript:void(0)"
    },
    on: {
      "click": function($event) {
        _vm.PrintValidity_Doc(_vm.CBValidityDetails.validity_doc)
      }
    }
  }, [_vm._v("View Document")]) : _vm._e()])]) : _vm._e()]) : _vm._e()], 1), _vm._v(" "), _c('b-col', {
    staticClass: "text-center",
    attrs: {
      "cols": "12"
    }
  }, [(_vm.CBValidityDetails.booking_id != '' || !_vm.CBValidityDetails.booking_no) ? _c('b-button', {
    staticClass: "mt-3 sm",
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitOtherConsoleBooking
    }
  }, [_vm._v(_vm._s(_vm.buttonTxt))]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3 sm",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.closeModalAddOther
    }
  }, [_vm._v("Close")])], 1)], 1)], 1), _vm._v(" "), _c('b-modal', {
    ref: "modal-CancelBooking-conf",
    attrs: {
      "id": "modal-CancelBooking-conf",
      "title": "Cancel Console Booking Confirmation",
      "centered": "",
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "hide-footer": ""
    }
  }, [(_vm.MessageFlag == true) ? _c('h1', [_vm._v(_vm._s(_vm.Message))]) : _vm._e(), _vm._v(" "), (_vm.MessageFlag == false) ? _c('form', {
    ref: "form"
  }, [_c('b-form-group', {
    attrs: {
      "label": "Reason for Cancel Console Booking",
      "label-for": "name-input",
      "invalid-feedback": "Name is required"
    }
  }, [_c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "rows": "5",
      "id": "name-input",
      "required": ""
    },
    on: {
      "keyup": _vm.closingReason
    },
    model: {
      value: (_vm.closingReasontxt),
      callback: function($$v) {
        _vm.closingReasontxt = $$v
      },
      expression: "closingReasontxt"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.closingReasontxterr))])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.MessageFlag == false) ? _c('b-button', {
    attrs: {
      "disabled": _vm.iscloseCBdisabled ? false : true,
      "variant": "success"
    },
    on: {
      "click": _vm.updateCancelBooking
    }
  }, [_vm._v("Confirm & Close Billing")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "pull-right",
    attrs: {
      "variant": "danger"
    },
    on: {
      "click": _vm.closeCancelBookingModal
    }
  }, [_vm._v("Cancel")])], 1), _vm._v(" "), _c('b-modal', {
    ref: "ApprovalRequestModal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "title": "Console Booking Approval Request",
      "size": _vm.showRequestCBType == 2 ? 'xs' : 'xl',
      "hide-footer": ""
    },
    on: {
      "hidden": _vm.closeApprovalRequestModal
    }
  }, [(_vm.showRequestCBType == 2) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "delay_reason"
    }
  }, [_vm._v("Reason : "), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.delayReasonList,
      "id": "delay_reason",
      "option-value": "value",
      "option-text": "label",
      "placeholder": "Select Reason"
    },
    model: {
      value: (_vm.delay_reason),
      callback: function($$v) {
        _vm.delay_reason = $$v
      },
      expression: "delay_reason"
    }
  })], 1), _vm._v(" "), (_vm.delay_reason == 'Delay at Shipping Line') ? _c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('label', {
    attrs: {
      "for": "delay_reason_remark"
    }
  }, [_vm._v("Remark : *")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "id": "delay_reason_remark",
      "placeholder": "Pls Enter Remark",
      "type": "text"
    },
    model: {
      value: (_vm.delay_reason_remark),
      callback: function($$v) {
        _vm.delay_reason_remark = $$v
      },
      expression: "delay_reason_remark"
    }
  })], 1) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.showRequestCBType == 1) ? _c('b-row', {
    staticClass: "mb-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-table', {
    staticClass: "position-relative",
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "responsive": "",
      "items": _vm.CBApprovalLogList,
      "fields": _vm.CBApprovalLogFields,
      "primary-key": "clientId",
      "per-page": _vm.pagination.perPage,
      "sort-by": _vm.sortBy,
      "sort-desc": _vm.sortDesc,
      "sort-direction": _vm.sortDirection
    },
    on: {
      "update:sortBy": function($event) {
        _vm.sortBy = $event
      },
      "update:sortDesc": function($event) {
        _vm.sortDesc = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "SN",
      fn: function(row0) {
        return [_c('span', [_vm._v(_vm._s(row0.index + 1 + (_vm.pagination.currentPage - 1) * _vm.pagination.perPage))])]
      }
    }])
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('b-row', {
    staticClass: "justify-content-end"
  }, [(_vm.showRequestCBType == 2) ? _c('b-button', {
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "disabled": _vm.delay_reason ? false : true,
      "variant": "primary"
    },
    on: {
      "click": _vm.sendApprovalRequest
    }
  }, [_vm._v("Send")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "ml-2",
    staticStyle: {
      "font-size": "0.675rem"
    },
    attrs: {
      "variant": "secondary"
    },
    on: {
      "click": _vm.closeApprovalRequestModal
    }
  }, [_vm._v("Cancel")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3f5426a5","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/consoleBooking/ConsoleBooking.vue
// module id = 2548
// module chunks = 0